import React, {useState, useContext} from "react";
import axiosInstance from "../../../axiosConfig";
import {Backdrop, CircularProgress} from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import { AuthContext } from "../../../AuthContext";
import { capitalize } from "../../../util";
import './SettingsDelete.css';

import { ADMIN_API_URL } from "../../../config/apiParams";

function RetiredAPPDeletePopup({ 
    openDeleteSettings,
    setOpenDeleteSettings, 
    title, 
    mainTitle,
    selected,
    setIsToastOpen,
    setToastMessage,
    setLoading,
    setErrorCode
}) {
    const {organisationId, authData} = useContext(AuthContext);
    const {access_token, token_type} = authData
    const [openModel, setOpenModel] = useState(false);
    const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
    const handleModelOpen = () => setOpenModel(true);
    const handleModelClose = () => setOpenModel(false);

    const apiURLs = {
        Organization: {
           title: 'organisation',
           api: `organisation/${selected["Org ID"]}`
        },
        Project: {
            title: 'project',
            api: `project/${selected["Project ID"]}?org_id=${organisationId}`
        },
        User: {
            title: 'user',
            api: `user/${selected["User ID"]}`
        }, 
    }

    const getAPI = (title) => apiURLs[title]?.api || null;

    const handleDelete = async () => {
        setLoading(true);
        setOpenDeleteSettings(false);
        await axiosInstance({
            // Endpoint to send files
            url: `${ADMIN_API_URL}/${getAPI(title)}`,
            method: "DELETE",
            headers: {
            'Authorization': `${token_type} ${access_token}`
            },
        })
        .then((res) => {
            setLoading(false);
            setToastMessage(`${mainTitle} has been deleted successfully`);
            setIsToastOpen(true);
            setErrorCode(res?.status);
        })
        .catch((error) => {
            setLoading(false);
            const errorMessage = error.response?.data?.detail || error.message || 'Unknown error';
            setErrorCode(error?.response?.status);
            setToastMessage(`Error: ${errorMessage}`);
            setIsToastOpen(true)
        });
    };

  return (
    <div>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDeleteSettings}
            onClose={() => setOpenDeleteSettings(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
            backdrop: {
                timeout: 500,
            },
            }}
            className="retiredDeleteModalContainer"
        >
            <Fade in={openDeleteSettings}>
                <Box className="retiredDeleteModal">
                    <div className="retiredDeleteModalHeader">
                        <div className="retiredDeleteModalHeading">
                            Delete {capitalize(mainTitle)}
                        </div>
                        <span className="retiredDeleteModalClose" onClick={() => setOpenDeleteSettings(false)}>
                            &times;
                        </span>
                    </div>
                    <div className="retiredDeleteModalBody">
                        <div className="retiredDeleteModalBodyHeading">
                            Are you sure to delete {capitalize(mainTitle)}?
                        </div>
                    </div>
                    <div className="retiredDeleteModalFooter">
                        <Button 
                            className="cancelButton" 
                            variant="outlined" 
                            size="medium" 
                            onClick={() => setOpenDeleteSettings(false)}
                        >
                            No
                        </Button>
                        <Button 
                            className="deleteButton"  
                            variant="contained" 
                            color="success" 
                            size="medium" 
                            onClick={handleDelete}
                        >
                            Yes
                        </Button>
                    </div>
                </Box>
            </Fade>
        </Modal>
        <Modal
            open={openModel}
            className="genai-modal-custom"
            backdrop="static"
            keyboard={false}
            onClose={handleModelClose}
        >
            <div className="agentInUseModal"><h4>{deleteErrorMessage}</h4></div>
      </Modal>
    </div>
  )
}

export default RetiredAPPDeletePopup;